module.exports = __webpack_public_path__ + "img/1_02.b823a374.jpg";